


























import {
  Component,
  Prop,
  Vue,
  Watch,
  Model,
  PropSync,
} from 'vue-property-decorator';
import { Scope } from 'spraypaint';
import { ApplicationRecord } from '@/api';

@Component({
  components: {},
})
export default class extends Vue {
  @Prop({ required: true }) readonly headers: any[];
  @Prop({ default: true }) readonly singleSelect: boolean;
  @Prop({ default: true }) readonly showSelect: boolean;
  @Prop({ default: () => ({}) }) readonly defaultOptions: any;
  @Prop({ required: true }) readonly scopeFactory: () => Scope<
    ApplicationRecord
  >;
  @Prop({ required: false }) readonly mobileBreakpoint: number | string;
  @PropSync('selected', { default: () => [] })
  syncedSelected!: ApplicationRecord[];

  loading: boolean = false;

  total: number = 0;

  items: ApplicationRecord[] = [];

  options = {
    sortBy: [],
    sortDesc: [],
    page: 1,
    itemsPerPage: 20,
  };

  itemClicked(item: ApplicationRecord) {
    this.$emit('item-clicked', item);
  }

  async update() {
    this.loading = true;
    try {
      const itemsPerPage =
        this.options.itemsPerPage === -1 ? 10000 : this.options.itemsPerPage;
      let scope = this.scopeFactory()
        .page(this.options.page)
        .per(itemsPerPage);

      this.options.sortBy.forEach((sort, i) => {
        const order: any = {};
        order[sort] = this.options.sortDesc[i] ? 'desc' : 'asc';
        scope = scope.order(order);
      });

      const result = await scope.all();
      this.items = result.data;
      this.total = result.meta.pagination.count;
    } catch (e) {
      this.items = [];
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    this.options = { ...this.options, ...this.defaultOptions };
  }

  @Watch('options', { deep: true })
  optionsChanged(val: any, oldVal: any) {
    if (JSON.stringify(val) === JSON.stringify(oldVal)) {
      return;
    }
    this.update();
  }
}
